// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eU_70v::backdrop {
  background: var(--neutral-dark-opacity-50);
}

.eU_70v {
  border: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 884px;
  height: 528px;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  padding: var(--spacing-3);
  gap: var(--spacing-3);
  box-sizing: border-box;
  cursor: default;
}

.zVFgNw {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 53px;
  width: 100%;
}

.FxInoy {
  display: flex;
  flex-direction: column;
}

.Hpinvu {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  color: var(--text-neutral-dark);
  text-align: left;
}

.wCJ24f {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  text-align: left;
}

.onNaNl {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  color: var(--text-neutral-dark);
  cursor: pointer;
  border: none;
  background: none;
  box-sizing: border-box;
}

.NE9Zmg {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-2);
  overflow-y: hidden;
  padding: var(--spacing-0-5);
}

.EwT2nl {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mGWOiK {
  display: flex;
  flex: 1;
  width: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: var(--spacing-1);
  }
  &::-webkit-scrollbar-thumb {
    width: var(--spacing-1);
    background-color: var(--text-neutral-subtle);
    border-radius: var(--radius-m);
  }
}

.GBtZ3x {
  width: calc(100% - var(--spacing-1));
  border-spacing: 0 var(--spacing-1);
  border-collapse: separate;
  height: fit-content;
}

.k5k1WL {
  height: 48px;
  width: 100%;
  padding-left: var(--spacing-1-5);
  padding-right: var(--spacing-1-5);
}

.AYz5wH {
  width: 40px;
}

.JEVaci {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  text-align: left;
  border-radius: var(--radius-s);
  cursor: pointer;
}

.lyxG3D {
  height: 48px;
  width: 100%;
  padding-left: var(--spacing-1-5);
  padding-right: var(--spacing-1-5);
}

.dGAUVC {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  text-align: left;
  background: var(--background-alt);
  cursor: pointer;
}

.dGAUVC td {
  max-width: 30ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 48px;
}

.dGAUVC td,
.JEVaci th {
  padding-left: var(--spacing-1-5);
  padding-right: var(--spacing-1-5);
}

.dGAUVC td:first-child {
  border-top-left-radius: var(--radius-s);
  border-bottom-left-radius: var(--radius-s);
}

.dGAUVC td:last-child {
  border-top-right-radius: var(--radius-s);
  border-bottom-right-radius: var(--radius-s);
}

.i1HgEz {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--surface-neutral-white);
  border: 1px solid var(--on-surface-neutral-stronger);
  cursor: pointer;
  padding: 0;
  box-sizing: border-box;
}

.zgFtQz {
  background: var(--brand-tr-orange);
  border: 1px solid var(--brand-tr-orange);
}

.ABvOYl {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--surface-neutral-white);
  box-sizing: border-box;
  flex-shrink: 0;
}

.WyLUvr {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: var(--spacing-1);
}

.vjILgU {
  margin-top: var(--spacing-2);
}

.xvpYWB {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
}

.K4P2Tt {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
}

.v3R90F {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
}

.wByATR {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  gap: var(--spacing-2);
}

.CHGWWC {
  height: 40px;
  width: 100px;
  padding-top: var(--spacing-1);
  padding-right: var(--spacing-1-5);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--surface-neutral-white);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-primary-medium);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
}

.RrdaJX {
  height: 40px;
  width: 100px;
  padding-top: var(--spacing-1);
  padding-right: var(--spacing-1-5);
  padding-bottom: var(--spacing-1);
  padding-left: var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--brand-tr-orange);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/AccountSelector/AccountSelector.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,4CAA4C;IAC5C,8BAA8B;EAChC;AACF;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,oDAAoD;EACpD,eAAe;EACf,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;EACxC,iCAAiC;EACjC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;EAC1C,kCAAkC;EAClC,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;AACjB","sourcesContent":[".modal::backdrop {\n  background: var(--neutral-dark-opacity-50);\n}\n\n.modal {\n  border: none;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 884px;\n  height: 528px;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-3);\n  gap: var(--spacing-3);\n  box-sizing: border-box;\n  cursor: default;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 53px;\n  width: 100%;\n}\n\n.headerText {\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  color: var(--text-neutral-dark);\n  text-align: left;\n}\n\n.caption {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  text-align: left;\n}\n\n.close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 16px;\n  width: 16px;\n  color: var(--text-neutral-dark);\n  cursor: pointer;\n  border: none;\n  background: none;\n  box-sizing: border-box;\n}\n\n.body {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-2);\n  overflow-y: hidden;\n  padding: var(--spacing-0-5);\n}\n\n.searchIcon {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tableContainer {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  overflow-y: auto;\n  &::-webkit-scrollbar {\n    width: var(--spacing-1);\n  }\n  &::-webkit-scrollbar-thumb {\n    width: var(--spacing-1);\n    background-color: var(--text-neutral-subtle);\n    border-radius: var(--radius-m);\n  }\n}\n\n.table {\n  width: calc(100% - var(--spacing-1));\n  border-spacing: 0 var(--spacing-1);\n  border-collapse: separate;\n  height: fit-content;\n}\n\n.tableHeader {\n  height: 48px;\n  width: 100%;\n  padding-left: var(--spacing-1-5);\n  padding-right: var(--spacing-1-5);\n}\n\n.tableHeaderItemEmpty {\n  width: 40px;\n}\n\n.tableHeaderItem {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  text-align: left;\n  border-radius: var(--radius-s);\n  cursor: pointer;\n}\n\n.tableBody {\n  height: 48px;\n  width: 100%;\n  padding-left: var(--spacing-1-5);\n  padding-right: var(--spacing-1-5);\n}\n\n.tableBodyItem {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  text-align: left;\n  background: var(--background-alt);\n  cursor: pointer;\n}\n\n.tableBodyItem td {\n  max-width: 30ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  height: 48px;\n}\n\n.tableBodyItem td,\n.tableHeaderItem th {\n  padding-left: var(--spacing-1-5);\n  padding-right: var(--spacing-1-5);\n}\n\n.tableBodyItem td:first-child {\n  border-top-left-radius: var(--radius-s);\n  border-bottom-left-radius: var(--radius-s);\n}\n\n.tableBodyItem td:last-child {\n  border-top-right-radius: var(--radius-s);\n  border-bottom-right-radius: var(--radius-s);\n}\n\n.selectButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--on-surface-neutral-stronger);\n  cursor: pointer;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.selectButtonSelected {\n  background: var(--brand-tr-orange);\n  border: 1px solid var(--brand-tr-orange);\n}\n\n.selectButtonInnerCircle {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--surface-neutral-white);\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n\n.emptyState {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  gap: var(--spacing-1);\n}\n\n.emptyStateIcon {\n  margin-top: var(--spacing-2);\n}\n\n.emptyStateTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n}\n\n.emptyStateCaption {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n}\n\n.emptyStateDescription {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n  gap: var(--spacing-2);\n}\n\n.cancelButton {\n  height: 40px;\n  width: 100px;\n  padding-top: var(--spacing-1);\n  padding-right: var(--spacing-1-5);\n  padding-bottom: var(--spacing-1);\n  padding-left: var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--surface-neutral-white);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-primary-medium);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n}\n\n.confirmButton {\n  height: 40px;\n  width: 100px;\n  padding-top: var(--spacing-1);\n  padding-right: var(--spacing-1-5);\n  padding-bottom: var(--spacing-1);\n  padding-left: var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--brand-tr-orange);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `eU_70v`,
	"header": `zVFgNw`,
	"headerText": `FxInoy`,
	"title": `Hpinvu`,
	"caption": `wCJ24f`,
	"close": `onNaNl`,
	"body": `NE9Zmg`,
	"searchIcon": `EwT2nl`,
	"tableContainer": `mGWOiK`,
	"table": `GBtZ3x`,
	"tableHeader": `k5k1WL`,
	"tableHeaderItemEmpty": `AYz5wH`,
	"tableHeaderItem": `JEVaci`,
	"tableBody": `lyxG3D`,
	"tableBodyItem": `dGAUVC`,
	"selectButton": `i1HgEz`,
	"selectButtonSelected": `zgFtQz`,
	"selectButtonInnerCircle": `ABvOYl`,
	"emptyState": `WyLUvr`,
	"emptyStateIcon": `vjILgU`,
	"emptyStateTitle": `xvpYWB`,
	"emptyStateCaption": `K4P2Tt`,
	"emptyStateDescription": `v3R90F`,
	"footer": `wByATR`,
	"cancelButton": `CHGWWC`,
	"confirmButton": `RrdaJX`
};
module.exports = ___CSS_LOADER_EXPORT___;
